import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, HeadContent, Outlet, Scripts } from '@tanstack/react-router'
import type React from 'react'
import { useState } from 'react'
import { AuthProvider } from '../auth/AuthContext'
import { GlobalTradePopup } from '../components/GlobalTradePopup'
import { ErrorBoundary } from '../components/ErrorBoundary'
import '../index.css'
// tRPC REMOVED — all data fetching uses direct API endpoints now

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 2000, // Data is fresh for 2s — prevents duplicate refetches on mount
            refetchOnWindowFocus: false, // Don't refetch when user alt-tabs back
        },
    },
})

export const Route = createRootRoute({
    // @ts-expect-error - meta property not typed in this version
    meta: () => [
        {
            charSet: 'utf-8',
        },
        {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1',
        },
        {
            title: 'Options Oracle',
        },
    ],
    component: RootComponent,
    notFoundComponent: () => <div className="p-4 text-center">Page Not Found</div>,
})

function RootComponent() {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <RootDocument>
                        <div className="min-h-screen bg-background font-sans antialiased text-foreground">
                            <Outlet />
                            <GlobalTradePopup />
                        </div>
                        {/* <TanStackRouterDevtools /> */}
                    </RootDocument>
                </AuthProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    )
}

function RootDocument({ children }: { children: React.ReactNode }) {
    return (
        <>
            {children}
            <Scripts />
        </>
    )
}
